import { Component, Input, OnInit} from '@angular/core';
import { AbstractControl, FormGroup, ControlContainer, FormGroupDirective } from '@angular/forms';
import { ApplicableCircumstanceCustomAttributes } from '../../interfaces/special-enrollment-qualification-page-proxy.interface';

interface ComponentFormControls {
  isApplicableCircumstance: AbstractControl;
}

@Component({
    selector: 'app-applicable-circumstance-single-page-proxy-form',
    templateUrl: './applicable-circumstance-single-page-proxy-form.component.html',
    styleUrls: ['./applicable-circumstance-single-page-proxy-form.component.scss'],
    standalone: false,
    //this allows us detect the form being used as a wrapper for this component in the parent component 
    viewProviders: [ 
      { 
        provide: ControlContainer,
        useExisting: FormGroupDirective
      } 
    ]
})
export class ApplicableCircumstanceSinglePageProxyFormComponent implements OnInit{

  @Input() componentDisplayAttributes: ApplicableCircumstanceCustomAttributes;

  radioForm: FormGroup;

  constructor(
    private formGroupDirective: FormGroupDirective,
  ) {} 

  ngOnInit(): void {
    //connect the parent form
    this.radioForm = this.formGroupDirective.form;

  }

  get radioFormControls(): ComponentFormControls{
    return this.radioForm.controls as unknown as ComponentFormControls;
  }

  inputChanged(type: any, event: any){
    this.radioForm.controls[this.componentDisplayAttributes.formControlAttributes.formControlName].updateValueAndValidity();
  }

}
